//@ts-nocheck

import React, { useEffect, useRef } from "react";
import MDBox from "components/MDBox";

const NotesEditor = ({ initialHtml, updateEmailContent, templateName }) => {
  const editorRef = useRef(null);
  const textareaRef = useRef(null);

  function cleanHTML(html) {
    return html;
  }

  useEffect(() => {
    if (typeof window === "undefined" || !textareaRef.current) return;

    if (!editorRef || !editorRef.current) {
      const editorConfig = {
        iframe: true,
        iframeStyle: `
                    html{margin: 0px;}
                    body{padding:10px;background:transparent;color:#000;position:relative;z-index:2;
                    user-select:auto;margin:0px;overflow:hidden;}
                    body:after{content:"";clear:both;display:block}
                `,
        buttons: ["bold", "italic", "underline", "ul", "ol", "brush", "paragraph"],
        toolbarAdaptive: false,
        toolbarButtonSize: "small",
        iconSize: 12,
        showCharsCounter: true,
        showXPathInStatusbar: false,
        askBeforePasteHTML: false,
        events: {
          change: () => {
            try {
              const newContent = editorRef.current?.getEditorValue();
              updateEmailContent(newContent);
            } catch (err) {
              console.warn("Jodit error on change:", err);
            }
          },
          keydown: (e) => {
            if (e.key === "Backspace") {
              const editor = editorRef.current;
              const html = editor?.getEditorValue()?.trim();

              if (!html || html === "<br>" || html === "<p><br></p>") {
                e.preventDefault();
                updateEmailContent(`<></>`);
                return false;
              }
            }
          },
        },
      };

      editorRef.current = new window.Jodit(textareaRef.current, editorConfig);
      editorRef.current.value = cleanHTML(initialHtml);
    }

    return () => {
      if (editorRef.current) {
        editorRef.current.destruct();
        editorRef.current = null;
      }
    };
  }, []);

  return (
    <div style={{ border: "1.5px solid #545453", lineHeight: "1.4", padding: 10 }}>
      <textarea ref={textareaRef} name="notesEditor" />
    </div>
  );
};

export default NotesEditor;
